// prevents empty field when names are null
export const getGenreString = (genres) => {
  if (!genres || !genres.length) {
    return null;
  }

  const genreNames = genres.reduce(
    (acc, { name }) => (name?.en || name ? [...acc, name?.en || name] : acc),
    []
  );
  if (!genreNames.length) {
    return null;
  }

  return genreNames.join(', ');
};
